<template>
	<div>
		<el-col :span="24" class="toolbar uptool" style="padding-bottom: 0px;">
			<el-form :inline="true">
				<el-form-item>
					<el-input placeholder="请输入内容" v-model="inputMore" class="input-with-select" size="small">
					    <el-select v-model="selectMore" slot="prepend" placeholder="请选择">
						    <el-option label="昵称" value="1"></el-option>
						    <el-option label="内容" value="2"></el-option>
					    </el-select>
				    <el-button slot="append" icon="el-icon-search" @click="Find">查询</el-button>
				  </el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="text" size="small" style="margin-left:10px;color: #000;cursor: auto;">快速筛选:</el-button>
				</el-form-item>
  				<el-form-item>
					<el-select v-model="IsRead" placeholder="全部状态" size="small" style="width: 100px;" @change="Quickfind">
	    				<el-option label="全部状态" value=""></el-option>
	    				<el-option label="已读" value="1"></el-option>
	    				<el-option label="未读" value="0"></el-option>
	  				</el-select>
  				</el-form-item>
				<el-form-item style="float: right;">
					<el-button type="primary" plain size="small" @click="Refresh">刷新</el-button>
				</el-form-item>
			</el-form>
		</el-col>
		
		<el-table :data="List" border v-loading="listloading" style="width: 100%" :max-height="maxHeight">
			<!--<el-table-column label="序号" prop="id" width="60"></el-table-column>-->
			<el-table-column label="状态" prop="is_read" width="60">
				<template slot-scope="scope">
        			<span v-if="scope.row.is_read == 1">已读</span>
        			<span v-if="scope.row.is_read == 0">未读</span>
      			</template>
			</el-table-column>
		    <el-table-column label="昵称" prop="nickname" width="120"></el-table-column>
		    <el-table-column label="手机" prop="cellphone" width="150"></el-table-column>
		    <el-table-column label="内容" prop="content"></el-table-column>
		    <el-table-column label="时间" prop="post_date" :formatter="dateFormat" width="160"></el-table-column>
		    <el-table-column label="操作" width="150">
		    	<template slot-scope="scope">
		    		<el-button v-if="Limits.feedback_delete" type="danger" icon="el-icon-delete" size="mini" style="padding: 7px;" @click="Delete(scope.$index,scope.row)"></el-button>
		    		<el-button v-if="scope.row.is_read == 0 && Limits.feedback_read" type="success" size="small" @click="Goisread(scope.$index,scope.row)">标为已读</el-button>
		    		<el-button v-if="scope.row.is_read == 1 && Limits.feedback_read" type="warning" size="small" @click="Gounread(scope.$index,scope.row)">标为未读</el-button>
		    	</template>
		    </el-table-column>
		</el-table>
		
		<el-col :span="24" class="toolbar downtool">
			<el-button v-if="Limits.deletedfeedback_index" type="primary" size="small" @click="ShowDeleted">显示已删除反馈</el-button>
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="Pagesize" :current-page="Curpage" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
		
		<el-dialog title="已删除反馈" :visible.sync="DeleteVisible" :fullscreen="true" :before-close="Backchange">
			<div>
			<el-table :data="List2" border v-loading="listloading2">
			    <el-table-column label="昵称" prop="nickname" width="120"></el-table-column>
		    <el-table-column label="手机" prop="cellphone" width="150"></el-table-column>
		    <el-table-column label="内容" prop="content"></el-table-column>
		    <el-table-column label="时间" prop="post_date" :formatter="dateFormat" width="160"></el-table-column>
			    <el-table-column label="操作" width="60" v-if="Limits.deletedfeedback_enable">
			    	<template slot-scope="scope">
			    		<el-button type="success" size="mini" style="padding: 7px;" @click="Open(scope.$index,scope.row)">恢复</el-button>
			    	</template>
			    </el-table-column>
  			</el-table>
  		
  			<el-col :span="24" class="toolbar">
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange2" :page-size="Pagesize2" :current-page="Curpage2" :total="total2" style="float:right;">
			</el-pagination>
			</el-col>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	import {GetFeedbacklist,GetDelfeedbackslist} from '../api/api';
	
	export default {
		data(){
			return {
				token:"",
				maxHeight:600,
				Limits:"",
				inputMore:"",
				selectMore:"",
				List:[],
				listloading:false,
				Pagesize:20,
				Curpage:1,
				total:1,
				List2:[],
				listloading2:false,
				Pagesize2:20,
				Curpage2:1,
				total2:1,
				Form:{
					id:""
				},
				keyword:"",
				IsRead:"",
				DeleteVisible:false,
				MediumCode:1,
				Form2:{
					id:""
				},
				Screenall:{}
			}
		},
		methods:{
			Goisread(index,row){
				this.listloading = true
				this.Form = Object.assign({}, row);
				let urled = "/feedbacks/" + this.Form.id +"/readstatus?token=" + this.token
				this.axios.put(urled,{"is_read":1}).then(res => {
					if(res.status == "200"){
						this.$message({
			            	type: 'success',
			            	message: '操作成功!'
			          	});
			          	this.GetList(GetFeedbacklist,{page:this.Curpage,token:this.token,sort:"-post_date"})
					}else{
						this.$message.error('对不起，请求失败。')
						this.listloading = false
					}
				}).catch(err => {
					this.$message.error(err.response.data.message)
					this.listloading = false
				})
			},
			Gounread(index,row){
				this.listloading = true
				this.Form = Object.assign({}, row);
				let url = "/feedbacks/" + this.Form.id +"/readstatus?token=" + this.token
				this.axios.put(url,{"is_read":0}).then(res => {
					if(res.status == "200"){
						this.$message({
			            	type: 'success',
			            	message: '操作成功!'
			          	});
			          	this.GetList(GetFeedbacklist,{page:this.Curpage,token:this.token,sort:"-post_date"})
					}else{
						this.$message.error('对不起，请求失败。')
						this.listloading = false
					}
				}).catch(err => {
					this.$message.error(err.response.data.message)
					this.listloading = false
				})
			},
			Refresh(){
				this.inputMore = ""
				this.selectMore = ""
				this.IsRead = ""
				this.Curpage = 1
				this.GetList(GetFeedbacklist,{page:this.Curpage,token:this.token})
			},
			Quickfind(){
				var all
				if(this.inputMore && this.selectMore){
					if(this.selectMore == 1){
						all = {
							"nickname":'~'+this.inputMore,
							"is_read":this.IsRead,
						}
					}else if(this.selectMore == 2){
						all = {
							"content":'~'+this.inputMore,
							"is_read":this.IsRead,
						}
					}
				}else{
					all = {
						"is_read":this.IsRead
					}
				}
				this.Screenall = {}
				for(var i in all){
					if(all[i]){
						this.Screenall[i] = all[i]
							continue
						}
				}
				if(this.IsRead || (this.selectMore && this.inputMore)){
					this.GetList(GetFeedbacklist,{page:this.Curpage,token:this.token,sort:"-post_date",q:JSON.stringify([{"AND":this.Screenall}])})
				}else{
					this.GetList(GetFeedbacklist,{page:this.Curpage,token:this.token,sort:"-post_date"})
				}
			},
			Find(){
				if(this.selectMore && this.inputMore){
					this.Quickfind()
				}
			},
			handleCurrentChange(val){
				this.Curpage = val
				this.Quickfind()
			},
			Backchange(){
				if(this.MediumCode == 2){
					this.GetList(GetFeedbacklist,{page:this.Curpage,token:this.token,sort:"-post_date"})
					this.MediumCode = 1
				}
				this.DeleteVisible = false
			},
			handleCurrentChange2(val){
				this.Curpage2 = val
				this.GetList2(GetDelfeedbackslist,{page:this.Curpage2,token:this.token,sort:"-post_date"})
			},
			ShowDeleted(){
				this.DeleteVisible = true
				this.GetList2(GetDelfeedbackslist,{page:this.Curpage2,token:this.token,sort:"-post_date"})
			},
			Open(index,row){
				this.listloading2 = true
				this.Form2 = Object.assign({}, row);
				let ul = "/deletedfeedbacks/"+this.Form2.id+"/enable?token="+this.token
				this.axios.put(ul).then(res => {
					if(res.status == 200){
						this.$message({
			            	type: 'success',
			            	message: '恢复成功!'
			          	});
			          	this.MediumCode = 2
			          	this.GetList2(GetDelfeedbackslist,{page:this.Curpage2,token:this.token,sort:"-post_date"})
					}else{
						this.$message.error("对不起，请求失败。")
						this.listloading2 = false
					}
				}).catch(err => {
					this.$message.error(err.response.data.message)
					this.listloading2 = false
				})
			},
			Delete(index,row){
				this.$confirm('确认删除该条反馈?', '提示', {
			        confirmButtonText: '确定',
			        cancelButtonText: '取消',
			        type: 'warning'
			    }).then(()=>{
			    	this.listloading = true
					this.Form = Object.assign({}, row);
					let u = '/feedbacks/'+this.Form.id
					this.Del(u,GetFeedbacklist,{page:this.Curpage,token:this.token,sort:"-post_date"})
			    }).catch(()=>{
			    	this.$message({
			        	type: 'info',
			            message: '已取消删除'
			        });   
			    })
			}
		},
		created(){
			this.token = sessionStorage.getItem("BBRtoken");
			this.Limits = JSON.parse(sessionStorage.getItem("limits"))
			this.GetList(GetFeedbacklist,{page:this.Curpage,token:this.token,sort:"-post_date"})
		},
		mounted(){
			this.$nextTick(function(){
				this.Gethigh()
			})
		}
	}

</script>

<style scoped>
.el-select{
		width: 90px;
	}
</style>


// WEBPACK FOOTER //
// CustomerOpinion.vue?07a1cdaa